import {IntermediatePart} from "../../intermediatePart";
import {useOldCabinetLogic} from "../../constants";

export default class FridgeEnclosure extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'fridge_enclosure';
    this.partName = 'Fridge Enclosure';
    this.dbName = "Fridge Enclosure";
    this.visible = true;
    this.translateId = "visualizer.kitchen.appliance.fridge_enclosure";
    this.hasAdditionalParts = true;
    this.allWallsCanBeApplied = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData["RoomLayout"] && dbFeature.metaData["RoomLayout"].includes("Layout4")) {
      dbFeature.metaData["Part"] = ["0"]; // we don't have part 0 on Layout4
    }
    if (useOldCabinetLogic) {
      const partNumber = dbFeature.metaData["Part"] ? +dbFeature.metaData["Part"][0] : 0;
      return super.load_(dbFeature, new FridgeEnclosure(false, partNumber), true, partNumber === 0 ? 'features' : 'featuresParts');
    }
    const partNumber = dbFeature.metaData["Part"] ? dbFeature.metaData["Part"][0] : "1";
    return super.load_(dbFeature, new FridgeEnclosure(false, partNumber), true, partNumber === "1" ? 'features' : 'featuresParts');
  }

  navigationSubItems(...props) {
    const [, , , , restOptions = {}] = props;
    const layout = this.getParent().layout;
    if (layout.type === 1) {
      restOptions.returnAllFeatures = true;
      const navItems = super.navigationSubItems(...props);
      return navItems.map(nItem => {
        nItem.notAvailableInVisualizer = true;
        nItem.part = nItem.part.clone();
        nItem.part.notAvailableInVisualizer = true;
        return nItem
      })
    }
    return super.navigationSubItems(...props);
  }

  clone() {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
  }

  setLayers(layout) {

    if (layout.type === 4) {
      const fridge = this.getParent().fridge;
      // show layers only if fridge is disabled
      if (!(!fridge || fridge.disabled || !fridge.activeFeature || !fridge.activeFeature.layer || !fridge.activeFeature.layer.src)) {
        super.hideLayers();
        return
      }
    }

    return super.setLayers(layout);
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    const parent = this.getParent();
    //show second part only if fridge is disabled
    if (!parent.fridge || parent.fridge.disabled || !parent.fridge.activeFeature || !parent.fridge.activeFeature.layer || !parent.fridge.activeFeature.layer.src) {
      return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions, true);
    }
    return []
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const applianceParent = this.getParent();
    if (applianceParent && applianceParent.fridge && !applianceParent.fridge.disabled && applianceParent.fridge.activeFeature) {
      const fridgeConditions = applianceParent.fridge.getFridgeWidthAndHeightConditions();
      if (!fridgeConditions.some(condition => condition.propName === "Width")) {
        conditions.push({
          propName: "Width",
          propValue: "36"
        });
      }
      return [...conditions, ...fridgeConditions]
    }
    return conditions
  }

  getFridgeEnclosureSplittedFeatureName = () => {
    if (this._fridgeEnclosureSplittedFeatureName == null) {
      this._fridgeEnclosureSplittedFeatureName = this.getSplittedFeatureName().split(/.{5}$/)[0]; // "Benton Maple Stone-NC-Aspen-00 1 21" -> "Benton Maple Stone-NC-Aspen-00"
    }
    return this._fridgeEnclosureSplittedFeatureName
  };

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && Number.isInteger(fromFeature.partNumber)) {
      let activeFeaturePart;
      const name1 = fromFeature.getFridgeEnclosureSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);
      // if (this.partId === "right_wall") {
      //   arrayOfConditions = arrayOfConditions.filter(condition => condition.propName !== "MirrorSize");
      // }
      activeFeatureParts = this.featuresParts.filter((feature) => name1 === feature.getFridgeEnclosureSplittedFeatureName());
      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      if (activeFeatureParts.length) {
        activeFeaturePart = activeFeatureParts.find((feature) => {
          return feature.matchesMetaForArrayOfConditions(arrayOfConditions)
        });
        if (!activeFeaturePart) {
          activeFeaturePart = activeFeatureParts[0];
        }
      }
      activeFeatureParts = activeFeaturePart ? [activeFeaturePart] : [];
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

}
